/** verification group: KYB verification (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const verificationPermissions = ['verification:read', 'verification:manage'] as const;

export type VerificationPermission = (typeof verificationPermissions)[number];
